import { css } from '@emotion/react';
import { color, spacing } from '@uniquegood/realworld-studio-design';

export const templateItemRadioButton = css`
  align-items: initial;

  .check-box {
    overflow: initial;
    width: 16px;
    height: 16px;
  }

  label {
    width: 146px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const TemplateItemStyle = css`
  border-radius: ${spacing.borderRadius.large};
  width: fit-content;
  position: relative;
`;

export const templateItemThumbnail = css`
  display: grid;
  place-items: center;

  width: 173px;
  height: 138px;

  background-color: #c4c4c4;
  background-position: center;
  background-size: cover;

  border-radius: ${spacing.borderRadius.xlarge};

  .hover {
    display: none;
  }

  :hover > .hover,
  :focus-visible > .hover {
    display: grid;
    place-content: center;
  }

  padding: 0 ${spacing.padding.large};
`;

export const templateItemThumbnailDescription = css`
  margin-top: ${spacing.margin.xsmall};
  font-size: 12px;
  text-align: center;
  line-height: 20px;

  margin-bottom: ${spacing.margin.medium};

  color: ${color.text_white};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
